export default "__VITE_ASSET__c8661c66__"